import {TradingAccountReportModel} from '@spa/api';

import {
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData
} from '../../app/shared/components/report-table';

export const PanelSettingsGroupsEditAccountsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountReferenceIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<boolean>({
            colId: TradingAccountReportModel.getIsCashAccountSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountStatusNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getOwnerUserNameSelector(),
            value: null,
            hidden: false
        }),
    ];
};

export const PanelSettingsGroupsEditAccountsDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Account',
                selector: TradingAccountReportModel.getAccountReferenceIdSelector()
            }),
            new ReportTableColumn({
                label: 'Type',
                selector: TradingAccountReportModel.getIsCashAccountSelector()
            }),
            new ReportTableColumn({
                label: 'Status',
                selector: TradingAccountReportModel.getAccountStatusNameSelector()
            }),
            new ReportTableColumn({
                label: 'Client Name',
                selector: TradingAccountReportModel.getOwnerUserNameSelector()
            }),
        ],
        sortByRowIndex: true,
        hasToggleableOrCheckableRows: true,
        disableColumnsOptions: true,
        hiddenColumnIds: [],
        actionMenu: false
    };
};

